import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { mapParamsBySchema } from './../../util';
import { Login_Schema } from './Login_Schema';
import { apiRequest } from '../../Services/Common/ApiRequest';
import Global from '../../Services/Common/Global';
import { handleQuerySuccess } from './../../Hooks/apis/useQuriesSuccess';
import useSearchMutaion from './../../Hooks/apis/useSearchMutaion';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(Login_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Training', 'getTraCustom01R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Training.getTraCustom01R1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(Login_Schema.mapper.search2, context);
    return apiRequest('post', Global.urls.Training.getTraCustom01R2, params);
  }, successOptions);
};

/** 비상연락망 목록 조회 GetEmTelR1 (본인 부서) */
export const useSearch3 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(Login_Schema.mapper.search3, context);
    return apiRequest('post', Global.urls.EmergencyTel.GetEmTelR1, params);
  }, successOptions);
};
